import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { FleetService } from '../service/fleet.service';
import { tap } from 'rxjs/operators';

export const bbxInterceptor: HttpInterceptorFn = (req, next) => {
  const fleetService = inject(FleetService);

  if (req.url.includes('lite/bbx/non-attribuees/') && req.method === 'GET') {
    return next(req).pipe(
      tap((event: any) => {
        fleetService.bbxList.set(event.body);
      }),
    );
  }

  return next(req);
};
